var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFaceParts = function SvgFaceParts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 42.9999C24.647 42.9999 27.3333 40.3136 27.3333 36.9999C27.3333 33.6862 24.647 30.9999 21.3333 30.9999C18.0196 30.9999 15.3333 33.6862 15.3333 36.9999C15.3333 40.3136 18.0196 42.9999 21.3333 42.9999Z",
    stroke: "#2D3336",
    strokeWidth: 3.28875,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6667 42.9999C41.9804 42.9999 44.6667 40.3136 44.6667 36.9999C44.6667 33.6862 41.9804 30.9999 38.6667 30.9999C35.353 30.9999 32.6667 33.6862 32.6667 36.9999C32.6667 40.3136 35.353 42.9999 38.6667 42.9999Z",
    stroke: "#2D3336",
    strokeWidth: 3.28875,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6667 36.3333H27.3334V39H32.6667V36.3333Z",
    fill: "#2D3336"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6483 32.0197V20.2632C16.6483 16.39 20.9423 16.182 20.9423 20.2632",
    stroke: "#2D3336",
    strokeWidth: 3.28875,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2448 32.0197V20.2631C43.2448 16.3853 38.9508 16.1772 38.9508 20.2631",
    stroke: "#2D3336",
    strokeWidth: 3.28875,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
export default SvgFaceParts;